// IIFE
(($) => {
  $('.agenda-principal').on('click', '.agenda-ajax', function (event) {
    event.preventDefault();
    $('body').addClass('loading');
    // segue o link
    $.ajax(this.href, {timeout: 30000}).then(
      (resp) => {
        // carrega o html
        $('.agenda-principal').html($('.agenda-principal', $(resp)).html());
      },
      () => alert('Erro ao carregar os dados'),
    ).always(
      () => {
        $('body').removeClass('loading');
      },
    );
  });
})(jQuery);
